<style lang="less" type="text/less" scoped>

</style>
<template>

</template>
<script type="text/ecmascript-6">
    module.exports = {
        data: function () {
            return {}
        },
        methods: {},
        components: {},
        mounted: function () {
            require('../lib/UserService').logout('/');
        }
    }
</script>


// WEBPACK FOOTER //
// logout.vue?7d09ca26